<template>
  <v-dialog
    v-model="modal"
    persistent
    max-width="600"
  >
    <template #activator="{on, attrs}">
      <v-btn
        color="success"
        v-bind="attrs"
        v-on="on"
      >
        Adicionar
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        Adicionar na blacklist
      </v-card-title>
      <v-card-text>
        <v-row class="py-2">
          <v-col cols="5">
            <input-select
              id="input:type"
              v-model="fault.tipo"
              :items="types"
              label="Tipo"
              outlined
            />
          </v-col>
          <v-col cols="5">
            <input-text
              v-if="fault.tipo === 'Device'"
              id="input:value"
              v-model="fault.valor"
              label="Device id"
              outlined
            />
            <input-mask
              v-else
              id="input:value"
              v-model="fault.valor"
              label="Documento"
              outlined
            />
          </v-col>
          <v-col cols="2">
            <v-btn
              id="addItem"
              icon
              color="success"
              width="50"
              height="50"
              @click="add()"
            >
              <v-icon size="45">
                mdi-plus-circle
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row
          v-if="isList"
          class="py-2"
        >
          <v-col cols="12">
            <v-virtual-scroll
              :height="listHeight"
              item-height="50"
              :items="payload"
            >
              <template #default="{item, index}">
                <v-list-item :key="item">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ formatType(item.tipo) }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ formatValue(item.tipo, item.valor) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn
                      id="removeItem"
                      icon
                      color="primary"
                      width="25"
                      height="25"
                      @click="remove(index)"
                    >
                      <v-icon>
                        mdi-minus-circle
                      </v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-virtual-scroll>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          :loading="loading"
          @click="close()"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="success"
          :loading="loading"
          @click="save()"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BlackListTypes from '@/app/arch/enums/BlackListTypes';
import DocumentFilter from '@/app/arch/filters/DocumentFilter';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import BlacklistService from '../BlacklistService';

// eslint-disable-next-line no-new-object
const getNewItem = () => new Object({
  valor: '',
  tipo: '',
});

export default {
  name: 'BlacklistAddModal',
  mixins: [ServiceMixin],
  data: () => ({
    requestClass: BlacklistService,
    modal: false,
    payload: [],
    fault: getNewItem(),
    types: BlackListTypes,
    loading: false,
  }),
  computed: {
    isList() {
      return this.payload.length >= 1;
    },
    listHeight() {
      const size = this.payload.length;
      if (size > 3) {
        return '200';
      }
      return String(size * 50);
    },
    preparePayload() {
      return this.payload.map(
        (item) => {
          if (item.tipo !== 'Usuario') {
            return item;
          }

          return {
            tipo: item.tipo,
            valor: String(item.valor).replace(/[^0-9]/g, ''),
          };
        },
      );
    },
  },
  methods: {
    handleModal() {
      this.modal = !this.modal;
    },
    close() {
      this.payload = [];
      this.handleModal();
    },
    add() {
      this.payload.push(
        this.fault,
      );
      this.fault = getNewItem();
    },
    formatType(type) {
      return this.types.find(
        (t) => t.value === type,
      ).text;
    },
    formatValue(type, value) {
      switch (type) {
        case 'Usuario':
          return DocumentFilter(value);
        default:
          return value;
      }
    },
    remove(pos) {
      this.payload.splice(pos, 1);
    },
    save() {
      this.loading = true;
      this.callService(
        this.requestClass.save(
          this.preparePayload,
        ),
        () => {
          this.loading = false;
          this.$root.$emit('refresh-crud-BlacklistCrudList', true);
          this.handleModal();
        },
      );
    },
  },
};
</script>
